import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContendientesService } from '../../services/contendientes.service';
import copy from 'fast-copy';
import { Contendiente } from '../../interfaces/contendiente.interface';

@Component({
  selector: 'app-buscador-dos',
  templateUrl: './buscador-dos.component.html',
  styleUrls: ['./buscador-dos.component.css']
})
export class BuscadorDosComponent implements OnInit {
 idioma = 'es';
  loading: boolean = false;
  contendientesSinFiltro: Contendiente[] = [];
  contendientes: Contendiente[] = [];
  contendiente: any;
  fullTextString: any;
  keyWord: any;
  loadingPosts: boolean = true;
  files: any;
  catalog: any;
  error: any;
  termino: string = '';
  constructor(
    private api: ContendientesService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loading = false;
    this.activatedRoute.params.subscribe((params) => {
      this.loading = true;

      // console.log('OnInit, Inicio params');
      this.termino = params.termino;
      //  console.log('params.termino');
      //  console.log(params.termino);
      this.api
        .getContendientesFilter('')
        .subscribe((result: any) => {

          this.contendientesSinFiltro = result;
          // console.log('OnInit, this.contendientes');
          // console.log(this.contendientes);
          this.contendientesSinFiltro.forEach((element: Contendiente) => {
            const myData = copy(element);
            myData.Tipo = myData.NombreArchivo
              ? myData.NombreArchivo.split('.')[1]
              : myData.NombreArchivo;
            element = myData;
            // console.log('element');
            // console.log(element);
          });
          this.contendientes= this._filter(this.termino)

          this.loading = false;
        });
      // console.log('this.contendientes');
      // console.log(this.contendientes);
      // console.log('Fin params');
    });
  }
  private _filter(val: string) {
    const formatVal = val.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return this.contendientesSinFiltro.filter((a: any) =>
      (a.NombreDiputado != null && a.NombreDiputado.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(formatVal))     
    );
  }

  searchPosts() {
    const keyWordFilter = this.fullTextString ? null : this.keyWord;
    this.loadingPosts = true;
    this.api
      .searchPosts(keyWordFilter, this.fullTextString, this.files, this.catalog)
      .refetch()
      .then((result) => {
        this.loadingPosts = false;
        this.contendientes = result.data && result.data.filterContendientes23;
        this.contendientes.forEach((element: Contendiente) => {
          const myData = copy(element);
          myData.Tipo = myData.NombreArchivo
            ? myData.NombreArchivo.split('.')[1]
            : myData.NombreArchivo;
          element = myData;
          // console.log('element');
          // console.log(element);
        });
        this.loading = result.loading;
        this.error = result['error'];
      });
  }
  
  VerCarta(Oid:String){
    if (Oid) {
      let url = `/documento/1/${Oid.split('').reverse().join('')}`;
      window.open(url, '_blank');
    }
  }

  downloadBase64File(objeto: Contendiente) {
    // console.log('Contendiente:');
    // console.log(objeto);
    this.api.getContendiente(false, objeto.Oid).subscribe((data) => {
      // console.log('data:');
      // console.log(data);
      this.contendiente = null;
      if (data[0] !== undefined) {
        this.contendiente = data[0];
        const myData = copy(this.contendiente);
        myData.Tipo = myData.NombreArchivo
          ? myData.NombreArchivo.split('.')[1]
          : myData.NombreArchivo;
        this.contendiente = myData;
        let base64: any = null;
        let fileName: any = null;
        let fileType: any = null;
        if (this.contendiente) {
          base64 = this.contendiente.ArchivoB64;
          fileName = this.contendiente.NombreArchivo;
          // console.log('fileName');
          // console.log(fileName);
          fileType = this.contendiente.Tipo;
          // console.log('fileType');
          // console.log(fileType);
        }

        const linkSource = `data:application/${fileType};base64,${base64}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
      }
      this.loading = false;
    });
  }
}
